// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Density rules for the Person screen.
 *
 * The screen shows every author of a reference fully expanded, so vertical space is
 * the scarce resource: person_editor.cgi fits an author's whole form in a couple of
 * lines and this has to as well, or a twelve-author paper becomes a scroll marathon.
 * Bootstrap's default form spacing is far too generous for that, so it is overridden
 * here in one place rather than with inline styles on every control. */

/* .App sets text-align: center on the whole app (App.css), which every descendant
 * inherits; .Col-general quietly undoes it with text-align: left, which is why
 * dropping that class to normalise padding left this screen centred. Undo it once
 * here for the whole screen instead of per-column. */
.biblio-person {
  text-align: left;
}

/* The count and the create checkbox lead every author line, so they are fixed-width
 * columns rather than content-sized: "12 possible" and "0 possible" must put the
 * author's name at the same x position, or the list reads as ragged. */
.biblio-person-slot-possible {
  flex: 0 0 7.5rem;
}

.biblio-person-slot-create {
  flex: 0 0 5.5rem;
}

/* Labels for the reference context lines (title / cross references / main pdfs).
 * Fixed width so the three values line up under each other, and muted so the label
 * recedes behind the thing it names.
 *
 * Note for anyone tempted to use <em> here: App.css restyles em as a search
 * highlight (yellow background, upright), so it is not available as emphasis. */
.biblio-person-reflabel {
  display: inline-block;
  min-width: 8rem;
  color: #666;
  font-size: 0.8rem;
  vertical-align: top;
}

/* The who/when at the end of each row.
 *
 * Fixed width, because updated_by is not a uniform string -- an AGRKB curie on a row a
 * curator touched, a script name like "pubmed_search_new_references" on one an import
 * touched -- so a content-sized slot makes every row a different shape.
 *
 * But fixed at WHICH width depends on what the toggles are showing: reserving room for
 * both halves when only one is on leaves a column of empty space on every row. The
 * widths below are sized to the longest real content of each combination -- the
 * timestamp is a constant 19 characters, the curator is up to ~28 -- so the slot is
 * only ever as wide as it has to be. Anything longer still truncates, with the whole
 * value kept on the element's title. */
.biblio-person-slot-meta {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  /* Right-justified, to match what the person and laboratory screens do. The slot is
     wider than its text, and .biblio-person sets text-align: left, so without this the
     label sits at the left of its own column and lines up with nothing.
     margin-left: auto is for the stub rows, where no flex: 1 sibling exists to push
     the slot to the end of the line; on the author header one already does, and auto
     is a no-op there. */
  margin-left: auto;
  text-align: right;
}

.biblio-person-slot-meta-both {
  flex: 0 0 21rem;
}

.biblio-person-slot-meta-curator {
  flex: 0 0 12rem;
}

.biblio-person-slot-meta-time {
  flex: 0 0 8.5rem;
}

.biblio-person-author-head {
  display: flex;
  align-items: center;
  gap: 0.4rem;
}

/* Buttons that sit on a single-line row (remove, on an author's header line and on a
 * person-only row) have to match that line's density, not Bootstrap's default button
 * padding -- even size="sm" is tall enough to push the row open and add separation
 * the surrounding rows do not have.
 *
 * Deliberately not \`.biblio-person-author .btn\`: that would also catch "clear
 * selection" and "confirm selection" inside the expanded suggestions panel, which are
 * real actions on their own line and should stay full size. */
.biblio-person-author-head .btn,
.biblio-person-stub-row .btn {
  padding: 0 0.35rem;
  font-size: 0.8rem;
  line-height: 1.4;
}

.biblio-person .form-control,
.biblio-person .form-control-sm {
  padding: 0.1rem 0.3rem;
  height: auto;
  font-size: 0.85rem;
}

.biblio-person textarea.form-control {
  line-height: 1.2;
}

/* Bootstrap rows carry negative side margins and each column its own gutter; at this
 * density the gutters are most of the width. */
.biblio-person .row {
  margin-left: 0;
  margin-right: 0;
  margin-bottom: 0.15rem;
}

.biblio-person .row > [class*='col'] {
  padding-left: 0.15rem;
  padding-right: 0.15rem;
}

/* The gap between the screen's four top-level sections -- reference header, people
 * who are not authors, authors, institutions. Much larger than the rhythm inside a
 * section, which stays tight; the contrast is what makes the sections read as
 * separate rather than as one long list.
 *
 * Top margin only, on each section, so the gaps stay even when a section is absent:
 * the stubs list does not render at all when there are none, and Authors then
 * supplies its own spacing from the header. */
.biblio-person-section {
  margin-top: 2rem;
}

.biblio-person-staged-inst {
  border: 1px solid #ddd;
  padding: 0.25rem 0.35rem;
  margin-bottom: 0.3rem;
}

.biblio-person-author {
  border: 1px solid #ccc;
  padding: 0.3rem 0.4rem;
  margin-bottom: 0.35rem;
}

/* The raw affiliation and the "N possible" toggle are reference material, not the
 * thing being filled in, so they recede. */
.biblio-person-muted {
  color: #666;
  font-size: 0.8rem;
}

/* The possible-people count is collapsed by default and acts as a disclosure
 * control, so it has to read as clickable without being a full button. */
.biblio-person-toggle {
  background: none;
  border: none;
  padding: 0;
  color: #06c;
  text-decoration: underline;
  cursor: pointer;
  font-size: 0.85rem;
}

.biblio-person-toggle:disabled {
  color: #999;
  cursor: default;
}

/* The typeahead is a third-party control; shrink its input to match the rest. */
.biblio-person .rbt-input-multi,
.biblio-person .rbt-input-main {
  font-size: 0.85rem;
  padding: 0.1rem 0.3rem;
  min-height: 0;
}

.biblio-person .alert {
  padding: 0.25rem 0.5rem;
  margin-bottom: 0.3rem;
  font-size: 0.85rem;
}

.biblio-person .form-check {
  min-height: 0;
  margin-bottom: 0.05rem;
}

.biblio-person .form-check-label {
  font-size: 0.85rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/biblio/biblioPerson.css"],"names":[],"mappings":"AAAA;;;;;;uEAMuE;;AAEvE;;;qDAGqD;AACrD;EACE,gBAAgB;AAClB;;AAEA;;uEAEuE;AACvE;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;gFAKgF;AAChF;EACE,qBAAqB;EACrB,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;;;;;;;;;;uCAWuC;AACvC;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB;;;;;wBAKsB;EACtB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;;;;;;;8DAO8D;AAC9D;;EAEE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;+CAC+C;AAC/C;EACE,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;;;;;;;8CAO8C;AAC9C;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;2CAC2C;AAC3C;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;yEACyE;AACzE;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA,gFAAgF;AAChF;;EAEE,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":["/* Density rules for the Person screen.\n *\n * The screen shows every author of a reference fully expanded, so vertical space is\n * the scarce resource: person_editor.cgi fits an author's whole form in a couple of\n * lines and this has to as well, or a twelve-author paper becomes a scroll marathon.\n * Bootstrap's default form spacing is far too generous for that, so it is overridden\n * here in one place rather than with inline styles on every control. */\n\n/* .App sets text-align: center on the whole app (App.css), which every descendant\n * inherits; .Col-general quietly undoes it with text-align: left, which is why\n * dropping that class to normalise padding left this screen centred. Undo it once\n * here for the whole screen instead of per-column. */\n.biblio-person {\n  text-align: left;\n}\n\n/* The count and the create checkbox lead every author line, so they are fixed-width\n * columns rather than content-sized: \"12 possible\" and \"0 possible\" must put the\n * author's name at the same x position, or the list reads as ragged. */\n.biblio-person-slot-possible {\n  flex: 0 0 7.5rem;\n}\n\n.biblio-person-slot-create {\n  flex: 0 0 5.5rem;\n}\n\n/* Labels for the reference context lines (title / cross references / main pdfs).\n * Fixed width so the three values line up under each other, and muted so the label\n * recedes behind the thing it names.\n *\n * Note for anyone tempted to use <em> here: App.css restyles em as a search\n * highlight (yellow background, upright), so it is not available as emphasis. */\n.biblio-person-reflabel {\n  display: inline-block;\n  min-width: 8rem;\n  color: #666;\n  font-size: 0.8rem;\n  vertical-align: top;\n}\n\n/* The who/when at the end of each row.\n *\n * Fixed width, because updated_by is not a uniform string -- an AGRKB curie on a row a\n * curator touched, a script name like \"pubmed_search_new_references\" on one an import\n * touched -- so a content-sized slot makes every row a different shape.\n *\n * But fixed at WHICH width depends on what the toggles are showing: reserving room for\n * both halves when only one is on leaves a column of empty space on every row. The\n * widths below are sized to the longest real content of each combination -- the\n * timestamp is a constant 19 characters, the curator is up to ~28 -- so the slot is\n * only ever as wide as it has to be. Anything longer still truncates, with the whole\n * value kept on the element's title. */\n.biblio-person-slot-meta {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  /* Right-justified, to match what the person and laboratory screens do. The slot is\n     wider than its text, and .biblio-person sets text-align: left, so without this the\n     label sits at the left of its own column and lines up with nothing.\n     margin-left: auto is for the stub rows, where no flex: 1 sibling exists to push\n     the slot to the end of the line; on the author header one already does, and auto\n     is a no-op there. */\n  margin-left: auto;\n  text-align: right;\n}\n\n.biblio-person-slot-meta-both {\n  flex: 0 0 21rem;\n}\n\n.biblio-person-slot-meta-curator {\n  flex: 0 0 12rem;\n}\n\n.biblio-person-slot-meta-time {\n  flex: 0 0 8.5rem;\n}\n\n.biblio-person-author-head {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n}\n\n/* Buttons that sit on a single-line row (remove, on an author's header line and on a\n * person-only row) have to match that line's density, not Bootstrap's default button\n * padding -- even size=\"sm\" is tall enough to push the row open and add separation\n * the surrounding rows do not have.\n *\n * Deliberately not `.biblio-person-author .btn`: that would also catch \"clear\n * selection\" and \"confirm selection\" inside the expanded suggestions panel, which are\n * real actions on their own line and should stay full size. */\n.biblio-person-author-head .btn,\n.biblio-person-stub-row .btn {\n  padding: 0 0.35rem;\n  font-size: 0.8rem;\n  line-height: 1.4;\n}\n\n.biblio-person .form-control,\n.biblio-person .form-control-sm {\n  padding: 0.1rem 0.3rem;\n  height: auto;\n  font-size: 0.85rem;\n}\n\n.biblio-person textarea.form-control {\n  line-height: 1.2;\n}\n\n/* Bootstrap rows carry negative side margins and each column its own gutter; at this\n * density the gutters are most of the width. */\n.biblio-person .row {\n  margin-left: 0;\n  margin-right: 0;\n  margin-bottom: 0.15rem;\n}\n\n.biblio-person .row > [class*='col'] {\n  padding-left: 0.15rem;\n  padding-right: 0.15rem;\n}\n\n/* The gap between the screen's four top-level sections -- reference header, people\n * who are not authors, authors, institutions. Much larger than the rhythm inside a\n * section, which stays tight; the contrast is what makes the sections read as\n * separate rather than as one long list.\n *\n * Top margin only, on each section, so the gaps stay even when a section is absent:\n * the stubs list does not render at all when there are none, and Authors then\n * supplies its own spacing from the header. */\n.biblio-person-section {\n  margin-top: 2rem;\n}\n\n.biblio-person-staged-inst {\n  border: 1px solid #ddd;\n  padding: 0.25rem 0.35rem;\n  margin-bottom: 0.3rem;\n}\n\n.biblio-person-author {\n  border: 1px solid #ccc;\n  padding: 0.3rem 0.4rem;\n  margin-bottom: 0.35rem;\n}\n\n/* The raw affiliation and the \"N possible\" toggle are reference material, not the\n * thing being filled in, so they recede. */\n.biblio-person-muted {\n  color: #666;\n  font-size: 0.8rem;\n}\n\n/* The possible-people count is collapsed by default and acts as a disclosure\n * control, so it has to read as clickable without being a full button. */\n.biblio-person-toggle {\n  background: none;\n  border: none;\n  padding: 0;\n  color: #06c;\n  text-decoration: underline;\n  cursor: pointer;\n  font-size: 0.85rem;\n}\n\n.biblio-person-toggle:disabled {\n  color: #999;\n  cursor: default;\n}\n\n/* The typeahead is a third-party control; shrink its input to match the rest. */\n.biblio-person .rbt-input-multi,\n.biblio-person .rbt-input-main {\n  font-size: 0.85rem;\n  padding: 0.1rem 0.3rem;\n  min-height: 0;\n}\n\n.biblio-person .alert {\n  padding: 0.25rem 0.5rem;\n  margin-bottom: 0.3rem;\n  font-size: 0.85rem;\n}\n\n.biblio-person .form-check {\n  min-height: 0;\n  margin-bottom: 0.05rem;\n}\n\n.biblio-person .form-check-label {\n  font-size: 0.85rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
